import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation, ChangeDetectionStrategy, inject, viewChild, input} from '@angular/core';
import {NgbPopover} from '@ng-bootstrap/ng-bootstrap';

// Delay before closing on mouse leave, so the user has time to move the pointer
// from the trigger button onto the popover panel (e.g. to select/copy its text).
const CLOSE_DELAY_MS = 250;

@Component({
  selector: 'app-info-popover',
  templateUrl: './info-popover.component.html',
  styleUrls: ['./info-popover.component.css'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgbPopover]
})
export class InfoPopoverComponent implements OnInit, OnDestroy {
  private cdr = inject(ChangeDetectorRef);

  readonly info = input(undefined);
  readonly container = input(undefined);

  readonly popover = viewChild(NgbPopover);

  private closeTimer = null;

  constructor() {
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.cancelScheduledClose();
  }

  onMouseEnter(): void {
    this.cancelScheduledClose();
    this.popover().open();
  }

  onMouseLeave(): void {
    this.cancelScheduledClose();
    this.closeTimer = setTimeout(() => {
      this.popover().close();
      this.cdr.markForCheck();
    }, CLOSE_DELAY_MS);
  }

  private cancelScheduledClose(): void {
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
  }

}
